import { render } from "./HeaderYachts.vue?vue&type=template&id=6bb2ecf4"
import script from "./HeaderYachts.vue?vue&type=script&lang=js"
export * from "./HeaderYachts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__